"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactTransitionGroup = require("react-transition-group");
require("./animator.css");
var _excluded = ["animation", "children", "entranceDelay"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var durations = {
  fade: {
    enter: 400,
    exit: 100
  },
  fadeGrow: {
    enter: 200,
    exit: 100
  },
  grow: {
    enter: 200,
    exit: 100
  }
};

/**
 * An animation utility for preset entrance/exit animations using React Transition Group.
 * If rendering more than one child, or toggling the state of a single child,
 * be sure each child has a unique key.
 */
var Animator = function Animator(_ref) {
  var _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? 'fadeGrow' : _ref$animation,
    children = _ref.children,
    _ref$entranceDelay = _ref.entranceDelay,
    entranceDelay = _ref$entranceDelay === void 0 ? 100 : _ref$entranceDelay,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var wrapIntoCssTransition = function wrapIntoCssTransition(item, itemKey) {
    var _durations$animation, _durations$animation2, _durations$animation3;
    return /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
      classNames: "sb-animator-".concat(animation),
      key: itemKey,
      timeout: {
        appear: ((_durations$animation = durations[animation]) === null || _durations$animation === void 0 ? void 0 : _durations$animation.enter) + entranceDelay,
        enter: ((_durations$animation2 = durations[animation]) === null || _durations$animation2 === void 0 ? void 0 : _durations$animation2.enter) + entranceDelay,
        exit: (_durations$animation3 = durations[animation]) === null || _durations$animation3 === void 0 ? void 0 : _durations$animation3.exit
      }
    }, item);
  };
  var transitionChildren = [];
  _react["default"].Children.forEach(children, function (child) {
    if (! /*#__PURE__*/_react["default"].isValidElement(child)) {
      return;
    }
    var childKey = child === null || child === void 0 ? void 0 : child.key;
    var childWithDelay = /*#__PURE__*/(0, _react.cloneElement)(child, {
      style: {
        transitionDelay: "".concat(entranceDelay, "ms")
      }
    });
    transitionChildren.push(wrapIntoCssTransition(childWithDelay, childKey));
  });
  return /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.TransitionGroup, _extends({
    appear: true,
    component: null
  }, otherProps), transitionChildren);
};
Animator.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The name of the animation to be applied to children. Defaults to 'fadeGrow'.
   */
  animation: _propTypes["default"].oneOf(['fade', 'grow', 'fadeGrow']),
  children: _propTypes["default"].any,
  /**
   * Value in milliseconds before the entrance animation begins
   */
  entranceDelay: _propTypes["default"].number
} : {};
Animator.displayName = 'Animator';
var _default = exports["default"] = Animator;